import { ModalContext } from '@context/modalContext';
import { useContext, useEffect } from 'react';

export function useLoadingModal(isLoading: boolean, _label?: string) {
    const { setLoading } = useContext(ModalContext);

    useEffect(() => {
        setLoading(isLoading);

        // Cleanup: ensure loading is cleared when component unmounts
        return () => {
            if (isLoading) {
                setLoading(false);
            }
        };
    }, [isLoading, setLoading]);
}
